import React, { memo } from "react";
import { Transition, Affix, Box, Group, Tooltip } from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
import { useIsSmallScreen } from "../../Components/Utils";
import Icon from "../../Components/Icon";

const RelatedTableAffix = memo(function ({
  disabledCurrentBtn,
  onCurrentClick,
}: {
  disabledCurrentBtn?: boolean;
  onCurrentClick: () => void;
}) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_scroll, scrollTo] = useWindowScroll();
  const isSmallScreen = useIsSmallScreen();

  return (
    <Affix position={{ bottom: 150, right: isSmallScreen ? 15 : 20 }}>
      <Transition transition="slide-up" mounted>
        {(transitionStyles) => (
          <Group style={transitionStyles} sx={{ flexDirection: "column" }}>
            <Box
              onClick={() => scrollTo({ y: 0 })}
              sx={(theme) => ({
                borderRadius: 4,
                width: 30,
                height: 30,
                color: "#FFFFFF",
                backgroundColor:
                  theme.colorScheme === "dark" ? "#373A40" : "#CED4DA",
                "&:hover": {
                  backgroundColor: "#44D7B6",
                  color: "#FFFFFF",
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                boxShadow:
                  theme.colorScheme === "dark"
                    ? "0 4px 12px 0 rgba(0,0,0,0.50)"
                    : "0 4px 12px 0 #FFFFFF",
              })}
            >
              <Icon name="icon-top-filling" size={18} />
            </Box>
            {disabledCurrentBtn ? null : (
              <Tooltip label="Current Tx" position="left" withArrow>
                <Box
                  onClick={onCurrentClick}
                  sx={(theme) => ({
                    borderRadius: 4,
                    width: 30,
                    height: 30,
                    padding: 0,
                    color: "#FFFFFF",
                    backgroundColor:
                      theme.colorScheme === "dark" ? "#373A40" : "#CED4DA",
                    "&:hover": {
                      backgroundColor: "#44D7B6",
                      i: {
                        color: "#FFFFFF !important",
                      },
                    },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    boxShadow:
                      theme.colorScheme === "dark"
                        ? "0 4px 12px 0 rgba(0,0,0,0.50)"
                        : "0 4px 12px 0 #FFFFFF",
                    transform: "rotate(180deg)",
                  })}
                >
                  <Icon
                    name="icon-bx-current-location"
                    color="#009CFA"
                    size={18}
                  />
                </Box>
              </Tooltip>
            )}
            <Box
              onClick={() => scrollTo({ y: document.body.scrollHeight })}
              sx={(theme) => ({
                borderRadius: 4,
                width: 30,
                height: 30,
                color: "#FFFFFF",
                backgroundColor:
                  theme.colorScheme === "dark" ? "#373A40" : "#CED4DA",
                "&:hover": {
                  backgroundColor: "#44D7B6",
                  color: "#FFFFFF",
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                boxShadow:
                  theme.colorScheme === "dark"
                    ? "0 4px 12px 0 rgba(0,0,0,0.50)"
                    : "0 4px 12px 0 #FFFFFF",
                transform: "rotate(180deg)",
              })}
            >
              <Icon name="icon-top-filling" size={18} />
            </Box>
          </Group>
        )}
      </Transition>
    </Affix>
  );
});

export default RelatedTableAffix;
